export enum ProjectBlockStatus {
  BLOCK_TEXT = 'QUADRA_TEXTO',
  BLOCK_SELECT = 'QUADRA_SELECAO'
}
